/* eslint-disable no-unused-vars */

import OMT_UI_ScrollArea from './OMT_UI_ScrollArea';
import OMT_UI_ScrollBarConfig from './OMT_UI_ScrollBarConfig';

/**
 * class for windows with scrollable content
 */
export default class OMT_UI_RoundedScrollArea extends OMT_UI_ScrollArea {
  /**
   * constructor
   * @param {Phaser.Rectangle} scrollRect Rectangle for scrollable area
   * @param {number} cornerRadius size for rounded corners
   * @param {OMT_UI_ScrollBarConfig} scrollBarConfig Class refernece for the scroll bar. Should extend OMT_UI_ScrollBar.
   */
  constructor(scrollRect, cornerRadius, scrollBarConfig = null) {
    super(scrollRect, scrollBarConfig);
    this._initRoundedScrollMask(cornerRadius);
  }

  /**
   * override mask creation
   */
  _initScrollMask() {
    // we dont want this to get called
  }

  /**
   * init / apply the scroll mask
   */
  _initRoundedScrollMask(cornerRadius) {
    this._scrollMask = new Phaser.Graphics(game);
    this._scrollMask.beginFill(0xff0000);
    this._scrollMask.drawRoundedRect(0, 0, this._scrollRect.width, this._scrollRect.height, cornerRadius);
    this._scrollMask.endFill();
    this._scrollMask.enabled = false;
    this.addChildAt(this._scrollMask, 0);
    this._content.mask = this._scrollMask;
  }
}
